import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { apiUrl } from "src/app/global/global";
import { AdminService } from "src/app/services/admin.service";

@Component({
  selector: "app-about",
  templateUrl: "./about.component.html",
  styleUrls: ["./about.component.css"]
})
export class AboutComponent implements OnInit {

  employerDetails: any;

  constructor(private route: ActivatedRoute, private api: AdminService) {
    console.log(this.route);
    let employerID = this.route.parent?.snapshot.paramMap.get("id") || "";
    this.getEmployersList(employerID);
  }

  getEmployersList(employerID: string) {
    this.api.getDatas(apiUrl._employerDetailsById + "/" + employerID).subscribe(res => {
      this.employerDetails = res.data;
    })
  }
  ngOnInit(): void {
  }

}
